import { createContext, useContext } from "react";
import { FinancialDocumentBulkAction } from "@common/types/financialDocument";
import { noopAsync } from "@common/helpers/function";

interface FinancialDocumentBulkActionsContextValue {
    run(action: FinancialDocumentBulkAction): Promise<void>;
    busy: boolean;
}

export const financialDocumentBulkActionsContext =
    createContext<FinancialDocumentBulkActionsContextValue>({
        run: noopAsync,
        busy: false,
    });

export function useFinancialDocumentBulkActions() {
    return useContext(financialDocumentBulkActionsContext);
}
